// (c) 2023 ABBYY Development, Inc.

import { FC, useRef, useState } from 'react';
import { Box, CheckFill, CrossFill, Popper } from 'components';
import { TemplateSchedule } from 'types/template';

interface ScheduleIndicatorProps {
    schedule: TemplateSchedule;
}

const ScheduleIndicator: FC<ScheduleIndicatorProps> = ({
    schedule
}: ScheduleIndicatorProps) => {
    const iconRef = useRef<HTMLDivElement>();
    const [showPopper, setShowPopper] = useState(false);

    return (
        <Box display="flex" justifyContent="center">
            {schedule.enabled ? (
                <div
                    ref={iconRef}
                    onMouseEnter={() => setShowPopper(true)}
                    onMouseLeave={() => setShowPopper(false)}
                >
                    <Popper
                        isOpen={showPopper}
                        placement="left"
                        anchorElement={iconRef.current}
                        hasArrow
                    >
                        <div>
                            {schedule.days
                                .map((day) => day.substr(0, 3).toUpperCase())
                                .join(', ')}
                        </div>
                        <div>
                            {`${schedule.time.fromHours
                                .toString()
                                .padStart(2, '0')}:${schedule.time.fromMinutes
                                .toString()
                                .padStart(2, '0')} - ${schedule.time.toHours
                                .toString()
                                .padStart(2, '0')}:${schedule.time.toMinutes
                                .toString()
                                .padStart(2, '0')}`}
                        </div>
                    </Popper>
                    <CheckFill color="primary" />
                </div>
            ) : (
                <CrossFill color={['grey', 'A200']} />
            )}
        </Box>
    );
};

export default ScheduleIndicator;
